'use strict';

require('babel-polyfill');

var _vue = require('vue/dist/vue.js');

var _vue2 = _interopRequireDefault(_vue);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _vueAxios = require('vue-axios');

var _vueAxios2 = _interopRequireDefault(_vueAxios);

var _elementUi = require('element-ui');

var _elementUi2 = _interopRequireDefault(_elementUi);

var _vuelidate = require('vuelidate');

var _vuelidate2 = _interopRequireDefault(_vuelidate);

var _vueFloatLabel = require('vue-float-label/dist/vue-float-label.js');

var _vueFloatLabel2 = _interopRequireDefault(_vueFloatLabel);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

var _login = require('./components/login.vue');

var _login2 = _interopRequireDefault(_login);

var _forgotPassword = require('./components/forgot-password.vue');

var _forgotPassword2 = _interopRequireDefault(_forgotPassword);

var _message = require('./components/message.vue');

var _message2 = _interopRequireDefault(_message);

var _myAccount = require('./components/my-account.vue');

var _myAccount2 = _interopRequireDefault(_myAccount);

var _myAccountValidate = require('./components/my-account-validate.vue');

var _myAccountValidate2 = _interopRequireDefault(_myAccountValidate);

var _question = require('./components/question.vue');

var _question2 = _interopRequireDefault(_question);

var _questionSwitch = require('./components/question-switch.vue');

var _questionSwitch2 = _interopRequireDefault(_questionSwitch);

var _questionInput = require('./components/question-input.vue');

var _questionInput2 = _interopRequireDefault(_questionInput);

var _questionNumber = require('./components/question-number.vue');

var _questionNumber2 = _interopRequireDefault(_questionNumber);

var _questionTextarea = require('./components/question-textarea.vue');

var _questionTextarea2 = _interopRequireDefault(_questionTextarea);

var _questionSelect = require('./components/question-select.vue');

var _questionSelect2 = _interopRequireDefault(_questionSelect);

var _assessment = require('./components/assessment.vue');

var _assessment2 = _interopRequireDefault(_assessment);

var _progressAssessment = require('./components/progress-assessment.vue');

var _progressAssessment2 = _interopRequireDefault(_progressAssessment);

var _questionComment = require('./components/question-comment.vue');

var _questionComment2 = _interopRequireDefault(_questionComment);

var _history = require('./components/history.vue');

var _history2 = _interopRequireDefault(_history);

var _improvements = require('./components/improvements.vue');

var _improvements2 = _interopRequireDefault(_improvements);

var _switcher = require('./components/switcher.vue');

var _switcher2 = _interopRequireDefault(_switcher);

require('../scss/main.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueAxios2.default, _axios2.default);
_vue2.default.use(_elementUi2.default);
_vue2.default.use(_vueFloatLabel2.default);
_vue2.default.use(_vuelidate2.default);

_vue2.default.component('assessment', _assessment2.default);
_vue2.default.component('progress-assessment', _progressAssessment2.default);
_vue2.default.component('message', _message2.default);
_vue2.default.component('login', _login2.default);
_vue2.default.component('forgot-password', _forgotPassword2.default);
_vue2.default.component('my-account', _myAccount2.default);
_vue2.default.component('my-account-validate', _myAccountValidate2.default);
_vue2.default.component('question', _question2.default);
_vue2.default.component('question-switch', _questionSwitch2.default);
_vue2.default.component('question-input', _questionInput2.default);
_vue2.default.component('question-number', _questionNumber2.default);
_vue2.default.component('question-textarea', _questionTextarea2.default);
_vue2.default.component('question-select', _questionSelect2.default);
_vue2.default.component('question-comment', _questionComment2.default);
_vue2.default.component('history', _history2.default);
_vue2.default.component('improvements', _improvements2.default);
_vue2.default.component('switcher', _switcher2.default);

if (process.env.NODE_ENV === 'production') {
  _vue2.default.config.productionTip = false;
  _vue2.default.config.devtools = false;
  _vue2.default.config.silent = true;
} else {
  _vue2.default.config.productionTip = true;
  _vue2.default.config.devtools = true;
  _vue2.default.config.silent = false;
}

new _vue2.default({
  el: '#vueApp',
  store: _store2.default
});


//////////////////
// WEBPACK FOOTER
// ./public/js/main.js
// module id = ./public/js/main.js
// module chunks = 0